import React from 'react';
import { connect } from 'unistore/react';

import { TranslatedMessage } from 'common/components/Intl';
import { subtotal } from '../store/selectors';
import segment from 'common/segment';
import Button from 'common/components/Button';
import Ledger from 'apps/cart/components/sidebar/Ledger';
import { func, number } from 'prop-types';

export const ReviewLedger = ({ checkout, subtotal }) => {
  const handleNextClick = () => {
    segment.track('AS Builder Next CTA Selected');
    checkout();
  };

  const checkoutButton = (
    <Button
      className="button--vivid button--full-width"
      onClick={handleNextClick}
    >
      <TranslatedMessage id="plan_builder.cart.checkout" />
    </Button>
  );

  return (
    <div className="build-your-plan-review__ledger">
      <Ledger
        checkoutButton={checkoutButton}
        savings={0}
        shipping={0}
        showShipping={true}
        showTaxes={true}
        subtotal={subtotal}
        total={subtotal}
      />
    </div>
  );
};

ReviewLedger.propTypes = {
  checkout: func.isRequired,
  subtotal: number.isRequired,
};

const ConnectedReviewLedger = connect(state => ({
  subtotal: subtotal(state),
}))(ReviewLedger);

ConnectedReviewLedger.displayName = 'ConnectedReviewLedger';

export default ConnectedReviewLedger;
